import Service from "../../Services";

const Faq = {
  namespaced : true,
  state : {
    form : {
      is_publish : true,
      category_id : '',
      category_name : '',
      question_th : '',
      question_en : '',
      answer_th : '',
      answer_en : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        is_publish : true,
        category_id : '',
        category_name : '',
        question_th : '',
        question_en : '',
        answer_th : '',
        answer_en : '',
      }
    }
  },
  actions : {
    getFaq({commit}, {page,search}){
      return Service.FaqAPI.getFaq(page,search);
    },
    showFaq({commit},id){
      return Service.FaqAPI.showFaq(id);
    },
    saveFaq({commit},{id,data}){
      if(id){
        return Service.FaqAPI.updateFaq(id,data);
      }else{
        return Service.FaqAPI.createFaq(data);
      }
    },
    deleteFaq({commit},id){
      return Service.FaqAPI.deleteFaq(id);
    },
    setFormFaq({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Faq
